/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PaymentLinkLineItem,
  PaymentLinkLineItem$inboundSchema,
  PaymentLinkLineItem$Outbound,
  PaymentLinkLineItem$outboundSchema,
} from "./paymentlinklineitem.js";

/**
 * An optional collection of line items for a payment link.
 *
 * @remarks
 * When line items are provided, their total plus sales tax must equal the payment link amount.
 */
export type PaymentLinkLineItems = {
  /**
   * The list of line items.
   */
  items: Array<PaymentLinkLineItem>;
};

/** @internal */
export const PaymentLinkLineItems$inboundSchema: z.ZodType<
  PaymentLinkLineItems,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.array(PaymentLinkLineItem$inboundSchema),
});
/** @internal */
export type PaymentLinkLineItems$Outbound = {
  items: Array<PaymentLinkLineItem$Outbound>;
};

/** @internal */
export const PaymentLinkLineItems$outboundSchema: z.ZodType<
  PaymentLinkLineItems$Outbound,
  z.ZodTypeDef,
  PaymentLinkLineItems
> = z.object({
  items: z.array(PaymentLinkLineItem$outboundSchema),
});

export function paymentLinkLineItemsToJSON(
  paymentLinkLineItems: PaymentLinkLineItems,
): string {
  return JSON.stringify(
    PaymentLinkLineItems$outboundSchema.parse(paymentLinkLineItems),
  );
}
export function paymentLinkLineItemsFromJSON(
  jsonString: string,
): SafeParseResult<PaymentLinkLineItems, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PaymentLinkLineItems$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PaymentLinkLineItems' from JSON`,
  );
}
